import { render, staticRenderFns } from "./UserInfoDisplay.vue?vue&type=template&id=9589cac8&scoped=true"
import script from "./UserInfoDisplay.vue?vue&type=script&lang=js"
export * from "./UserInfoDisplay.vue?vue&type=script&lang=js"
import style0 from "./UserInfoDisplay.vue?vue&type=style&index=0&id=9589cac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9589cac8",
  null
  
)

export default component.exports